import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/index.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { clearAuthAtom } from "./lib/auth-store.js";
import { setUnauthorizedHandler } from "./lib/api-client.js";
import { ADMIN_LOGIN } from "./lib/paths.js";

export default function App(): JSX.Element {
  const clearAuth = useSetAtom(clearAuthAtom);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      clearAuth();
      // 强制跳登录页（router 内部 + 浏览器 history 一起重置）
      router.navigate(ADMIN_LOGIN, { replace: true });
    });
    return () => setUnauthorizedHandler(null);
  }, [clearAuth]);

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}
